import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { comparisonListData } from '@/common/enums/demo';

// const defaultComparisonList: Array<any> = comparisonListData.slice(1);
interface InitStata {
  number: number;
  comparisonList: Array<any>;
  comparisonSelected: Array<any>;
}

const initialState: InitStata = {
  number: 0,
  comparisonList: comparisonListData, // 选择页
  comparisonSelected: [], // 选中项
};

const customerSlice = createSlice({
  name: 'demo',
  initialState,
  reducers: {
    changeCount: (state = initialState, action: PayloadAction<number>) => {
      state.number = action.payload;
    },
    // 选择对比
    addComparison: (state = initialState, action: PayloadAction<any[]>) => {
      state.comparisonSelected = action.payload;
    },
  },
});

// 导出action
export const {
  changeCount,
  addComparison
} = customerSlice.actions;

export default customerSlice.reducer;
